export default {
  ['searchQuery']: state => state.searchQuery,
  ['searchResults']: state => state.searchResults,
}
